












import { Component, Prop, Vue } from 'vue-property-decorator';
import { AbstractItemModel } from '@/models/items/abstract-item-model';
import { ProductItem } from '@/models/items/product-item-model';

import axios from 'axios';
import { UploadUtils } from '@/utils/upload-utils';

import AbstractAddItemGoogleSearchStep1 from '@/components/add-flows/AbstractAddItem-GoogleSearch-Step1.vue';

import {GOOGLE_CUSTOM_SEARCH_CX_PRODUCT, GOOGLE_CUSTOM_SEARCH_API_KEY_PRODUCT} from '@/secrets';

@Component({components: {AbstractAddItemGoogleSearchStep1}})
export default class AddProductItem_Step1 extends Vue {
  item = new ProductItem();

  public goToNextStep(args: any) {
    this.$emit('go-to-next-step', args);
  }

  get searchCx() { 
    return GOOGLE_CUSTOM_SEARCH_CX_PRODUCT;
  }

  get searchKey() { 
    return GOOGLE_CUSTOM_SEARCH_API_KEY_PRODUCT;
  }
}
